module.exports = __webpack_public_path__ + "img/tms-side-panel-2-en.4624144a.svg";